const calendarMonthSetMonthAction = (config) => ({
  config,
  type: "CALENDAR_MONTH_SET_MONTH_ACTION",
});

export { calendarMonthSetMonthAction };
